import animateScrollTo from 'animated-scroll-to'
import React, { FunctionComponent } from 'react'

import { MemoryMenu } from '../MemoryMenu'
import { Query } from './query'
import {
  Arrow,
  BackgroundImage,
  Container,
  Data,
  ImageOverlay,
  SubTitle,
  Title,
} from './style'

export const Intro: FunctionComponent<{}> = () => {
  const scrollWindow = () => {
    const data = document.querySelector('.intro-data')
    if (data) {
      const windowScrollTop = window.scrollY || window.pageYOffset
      const dataRect = data.getBoundingClientRect()
      animateScrollTo(dataRect.top + dataRect.height + windowScrollTop, {
        speed: 1000,
      })
    }
  }

  const timeoutBase = 500

  return (
    <Query>
      {data => (
        <>
          <Container>
            <BackgroundImage
              sizes={data.backgroundImage.childImageSharp.fluid}
            />
            <ImageOverlay />
            <Data className="intro-data">
              <Title effect="fade-slide-left" effectTimeout={timeoutBase}>
                Bumblebeat
              </Title>
              <SubTitle
                effect="fade-slide-bottom"
                effectTimeout={timeoutBase + 500}
              >
                Vertraue auf dein Gehör
              </SubTitle>
              <MemoryMenu />
            </Data>
            <Arrow
              effectTimeout={timeoutBase + 1500}
              onClick={() => scrollWindow()}
            />
          </Container>
        </>
      )}
    </Query>
  )
}
